import Link from 'next/link';
import { isNullish } from '@witmetrics/utils/misc';
import {
  useActiveAccount,
  useActiveAccountCreditBalance,
} from '@witmetrics/data-store';
import Dialog from '@/components/Dialog';
import DialogBody from '@/components/Dialog/DialogBody';
import DialogTitle from '@/components/Dialog/DialogTitle';
import { buildCreditsUrl, classes, formatCredits } from './utils';

export type CreditsDialogProps = {
  onClose: () => void;
};

export default function CreditsDialog({ onClose }: CreditsDialogProps) {
  const activeAccount = useActiveAccount();
  const balance = useActiveAccountCreditBalance();

  if (isNullish(activeAccount)) return null;

  const url = buildCreditsUrl(
    activeAccount.accountType as 'PRACTICE' | 'LAB',
    activeAccount.accountId
  );

  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <DialogTitle title="Credits" onClose={onClose} />
      <DialogBody className={classes.body}>
        <span className={classes.summaryLabel}>Available balance</span>
        <span className={classes.summaryValue}>{formatCredits(balance)}</span>
        <p className={classes.description}>
          Manage credits & view transactions in account settings.
        </p>
        <Link
          className={classes.link}
          href={url}
          rel="noopener noreferrer"
          target="_blank">
          Manage Credits
        </Link>
      </DialogBody>
    </Dialog>
  );
}
